// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__eV9Br","boxTitle":"Qualiphy_boxTitle__38pV9","box":"Qualiphy_box__38imk","toggleWrap":"Qualiphy_toggleWrap__2fI7w"};